export const defaultPageTitle = "پارس ایمیجز بزرگترین سایت عکس استوک ایران - عکس ، وکتور ، کلیپ";
